<template>
  <i-button size="small" @click="click">
    <FFIcon type="copy" aria-hidden="true" />
  </i-button>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      value: null,
    };
  },
  methods: {
    click() {
      this.params.click(this.params.data);
    },
  },
});
</script>

<style lang="scss" module>
.grid-select-input {
  width: 100%;
  height: 100%;
}
</style>
